type BillingHistoryItem = {
  date: string
  amount: number
  status: 'paid' | 'pending' | 'failed'
}

type BillingHistoryProps = {
  data: BillingHistoryItem[]
}

export function BillingHistory({ data }: BillingHistoryProps) {
  return (
    <div className="mt-4 space-y-4">
      {data.map((item) => (
        <div
          key={item.date}
          className="flex justify-between items-center"
        >
          <div>
            <div className="font-medium">{item.date}</div>
            <div className="text-sm text-gray-500">${item.amount.toFixed(2)}</div>
          </div>
          <div className="flex items-center space-x-3">
            <span className="text-sm text-gray-700">{item.status}</span>
            <button className="text-gray-500 hover:text-gray-700">
              <svg
                className="w-5 h-5"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"
                />
              </svg>
            </button>
          </div>
        </div>
      ))}
    </div>
  )
}
